import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { rhAnalytics } from '../services/analyticsService';
import { isAdminUser } from '../utils/adminUtils';

interface AnalyticsTrackerProps {
  children: React.ReactNode;
}

const AnalyticsTracker: React.FC<AnalyticsTrackerProps> = ({ children }) => {
  const location = useLocation();
  const [adminFlagSet, setAdminFlagSet] = useState(false);

  useEffect(() => {
    // Detect admin status FIRST before initializing
    const auth = getAuth();
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const admin = await isAdminUser(user.uid);
        rhAnalytics.setAdminFlag(admin);
      } else {
        rhAnalytics.setAdminFlag(false);
      }
      
      // Only initialize after admin flag is set
      if (!adminFlagSet) {
        rhAnalytics.initialize();
        setAdminFlagSet(true);
      }
    });
    return unsub;
  }, [adminFlagSet]);

  useEffect(() => {
    // Only track page views after admin flag has been determined
    if (adminFlagSet) {
      rhAnalytics.trackPageView(location.pathname);
    }
  }, [location.pathname, adminFlagSet]);

  return <>{children}</>;
};

export default AnalyticsTracker;
